import { EVENT_NAME } from '../constants/eventBus';

interface eventObj {
  [eventName: string]: {
    [id: number]: Function;
  };
}
export default class EventBus {
  // 初始化事件列表
  eventObj: eventObj = {};
  callbackId = 0;
  constructor() {

  }

  /**
   * 发布事件
   * @param eventName
   * @param args
   */
  publish(eventName, ...args) {
    // 取出当前事件所有的回调函数
    const callbackObj = this.eventObj[eventName];
    if (!callbackObj) {
      return;
    }

    Object.values(callbackObj).forEach((callback) => {
      callback(...args);
    });
  }

  /**
   * 订阅事件
   * @param eventName
   * @param callback
   */
  subscribe(eventName, callback) {
    // 初始化事件
    if (!this.eventObj[eventName]) {
      this.eventObj[eventName] = {};
    }

    const id = this.callbackId++;
    // 存储订阅者的回调函数
    // callbackId使用后需要自增，供下一个回调函数使用
    this.eventObj[eventName][id] = callback;
    // 每一次订阅事件，都生成唯一一个取消订阅的函数
    const unSubscribe = () => {
      // 清除这个订阅者的回调函数
      delete this.eventObj[eventName][id];

      // 如果这个事件没有订阅者了，也把整个事件对象清除
      if (!Object.keys(this.eventObj[eventName]).length) {
        delete this.eventObj[eventName];
      }
    };
    return { unSubscribe };
  }

  /**
   * 订阅cell appear
   */
  subscribeCellAppear(indexPath, callback) {
    if (!indexPath) {
      return null;
    }
    const eventName = `${EVENT_NAME.CELLAPPEARPREFIX}${indexPath.section}_${indexPath.item}`;
    return this.subscribe(eventName, callback);
  }

  /**
   * 发布cell appear 事件
   */
  publishCellAppear(indexPath, ...args) {
    const eventName = `${EVENT_NAME.CELLAPPEARPREFIX}${indexPath.section}_${indexPath.item}`;
    this.publish(eventName, { ...args, indexPath });
  }
}
